import { IconProps } from '../../types';
import { useTheme } from 'styled-components';

const MeaningfulConversations = ({
  height = 65,
  width = 65,
  colorPrimary,
  colorSecondary,
  colorTertiary,
  className,
}: IconProps) => {
  const { midwestColors } = useTheme();
  const primary = colorPrimary ?? midwestColors.identityBrandPrimaryHeavy;
  const secondary =
    colorSecondary ?? midwestColors.semanticColorSentimentInfoMedium;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 112 112"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M62.5333 37.1933V41.0083C62.5333 42.0758 61.6699 42.9391 60.6083 42.9391H49.7408L46.9758 46.0366L44.1933 42.9391H41.4574C40.3899 42.9391 39.5266 42.0758 39.5266 41.0083V27.8716C39.5266 26.8041 40.3899 25.9408 41.4574 25.9408H44.8524V34.4575C44.8524 35.9683 46.0833 37.1933 47.5941 37.1933H62.5333Z"
        fill={primary}
      />
      <path
        d="M26.8217 72.7125C15.0734 72.7125 4.77173 82.0225 4.77173 92.6334V104.953H48.8659V92.6334C48.8659 82.0225 38.5642 72.7125 26.8217 72.7125ZM47.1159 103.203H6.52173V92.6334C6.52173 82.9559 16.0067 74.4625 26.8217 74.4625C37.6367 74.4625 47.1159 82.9559 47.1159 92.6334V103.203Z"
        fill={secondary}
      />
      <path
        d="M26.9793 42.4258C19.5651 42.4258 13.5334 48.4574 13.5334 55.8774C13.5334 63.2974 19.5651 69.3233 26.9793 69.3233C34.3934 69.3233 40.4251 63.2916 40.4251 55.8774C40.4251 48.4633 34.3934 42.4258 26.9793 42.4258ZM26.9793 67.5733C20.5276 67.5733 15.2834 62.3233 15.2834 55.8774C15.2834 49.4316 20.5276 44.1758 26.9793 44.1758C33.4309 44.1758 38.6751 49.4258 38.6751 55.8774C38.6751 62.3291 33.4251 67.5733 26.9793 67.5733Z"
        fill={secondary}
      />
      <path
        d="M109.83 92.6334V104.953H65.73V92.6334C65.73 82.0225 76.0316 72.7125 87.78 72.7125C99.5283 72.7125 109.83 82.0225 109.83 92.6334Z"
        fill={primary}
      />
      <path
        d="M101.383 55.8774C101.383 63.2916 95.3517 69.3233 87.9375 69.3233C80.5234 69.3233 74.4917 63.2916 74.4917 55.8774C74.4917 48.4633 80.5234 42.4258 87.9375 42.4258C95.3517 42.4258 101.383 48.4574 101.383 55.8774Z"
        fill={primary}
      />
      <path
        d="M81.48 8.47583H47.5942C46.0834 8.47583 44.8525 9.70083 44.8525 11.2117V34.4575C44.8525 35.9683 46.0834 37.1933 47.5942 37.1933H66.115L70.6242 42.3617L75.1567 37.1933H81.48C82.9909 37.1933 84.2159 35.9683 84.2159 34.4575V11.2117C84.2159 9.70083 82.9909 8.47583 81.48 8.47583ZM82.4659 34.4575C82.4659 35 82.0225 35.4433 81.48 35.4433H74.3634L70.6242 39.7075L66.9142 35.4433H47.5942C47.0459 35.4433 46.6025 35 46.6025 34.4575V11.2117C46.6025 10.6692 47.0459 10.2258 47.5942 10.2258H81.48C82.0225 10.2258 82.4659 10.6692 82.4659 11.2117V34.4575Z"
        fill={secondary}
      />
      <path
        d="M77.6649 18.1533C77.6649 18.6375 77.2683 19.0283 76.7899 19.0283H51.9341C51.4499 19.0283 51.0591 18.6375 51.0591 18.1533C51.0591 17.6692 51.4499 17.2783 51.9341 17.2783H76.7899C77.2683 17.2783 77.6649 17.6692 77.6649 18.1533Z"
        fill={secondary}
      />
      <path
        d="M77.6649 22.8667C77.6649 23.3509 77.2683 23.7417 76.7899 23.7417H51.9341C51.4499 23.7417 51.0591 23.3509 51.0591 22.8667C51.0591 22.3825 51.4499 21.9917 51.9341 21.9917H76.7899C77.2683 21.9917 77.6649 22.3825 77.6649 22.8667Z"
        fill={secondary}
      />
      <path
        d="M69.7083 27.5858C69.7083 28.07 69.3174 28.4608 68.8333 28.4608H51.9341C51.4499 28.4608 51.0591 28.07 51.0591 27.5858C51.0591 27.2533 51.2399 26.9675 51.5141 26.8158C51.6366 26.7516 51.7824 26.7108 51.9341 26.7108H68.8333C69.3174 26.7108 69.7083 27.1016 69.7083 27.5858Z"
        fill={secondary}
      />
    </svg>
  );
};

export default MeaningfulConversations;
